import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `Trang chủ trò chuyện ẩn danh ${ctx.brand}`,
    languageButtonLabel: `Ngôn ngữ`,
    languageModalTitle: `Chọn ngôn ngữ`,
    languageModalCloseLabel: `Đóng menu ngôn ngữ`,
  },
  languageOptions: {
    'en-US': {
      label: `Tiếng Anh (Hoa Kỳ)`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `Tiếng Anh (Kenya)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `Tiếng Anh (Nigeria)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `Tiếng Anh (Singapore)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `Tiếng Bồ Đào Nha (Bồ Đào Nha)`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Tiếng Bồ Đào Nha (Brazil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `Tiếng Đức (Đức)`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Tiếng Đức (Áo)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Tiếng Đức (Thụy Sĩ)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `Tiếng Tây Ban Nha (Tây Ban Nha)`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `Tiếng Pháp (Pháp)`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `Tiếng Italy (Italy)`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `Tiếng Hà Lan (Hà Lan)`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Tiếng Ba Lan (Ba Lan)`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `Tiếng Thụy Điển (Thụy Điển)`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Tiếng Đan Mạch (Đan Mạch)`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Tiếng Phần Lan (Phần Lan)`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Tiếng Na Uy (Na Uy)`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Tiếng Iceland (Iceland)`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `Tiếng Nhật (Nhật Bản)`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `Tiếng Hàn (Hàn Quốc)`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `Tiếng Trung (Trung Quốc)`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `Tiếng Quảng Đông (Đặc khu Hành chính Hồng Kông, Trung Quốc)`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt (Việt Nam)`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `Tiếng Thái (Thái Lan)`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Tiếng Indonesia (Indonesia)`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Tiếng Swahili (Kenya)`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `Tiếng Hindi (Ấn Độ)`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `Tiếng Bangla (Bangladesh)`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `Tiếng Marathi (Ấn Độ)`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `Tiếng Telugu (Ấn Độ)`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `Tiếng Ba Tư (Iran)`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `Tiếng Urdu (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `Tiếng Punjab (Pakistan)`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Pidgin Nigeria (Nigeria)`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `Tiếng Nga (Nga)`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `Tiếng Ả Rập (Ả Rập Xê-út)`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `Tiếng Ả Rập (Các Tiểu Vương quốc Ả Rập Thống nhất)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `Tiếng Ả Rập (Qatar)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `الدارجة المغربية`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Tiếng Thổ Nhĩ Kỳ (Thổ Nhĩ Kỳ)`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `Chọn ngôn ngữ`,
    closeLabel: `Đóng menu ngôn ngữ`,
  },
  languageHint: (ctx) => `Nhảy qua ${ctx.localesCount}+ ngôn ngữ mà không cần tạo tài khoản.`,
  readPagePrompt: ({languageLabel}) => `Đọc trang này bằng ${languageLabel}.`,
};
